export class EnrollmentConstant {
  static readonly ENROLLMENT_TOAST_SERVICE_INFO: string = "No Enrollment was found, so one was created";
  static readonly ENROLLMENT_ACCOUNT_SERVICE_CODE: string = "ADBT";
  static readonly ENROLLMENT_NCR_TELLER_NOT_SUPPORTED: string = "Using NCR and NetTell together is not currently supported";
  static readonly TYPE_CODE: string = "typeCode";
}
